import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'admin-lte/plugins/jquery/jquery.min.js'
import 'admin-lte/plugins/bootstrap/js/bootstrap.bundle.js'
import 'admin-lte/plugins/fontawesome-free/css/all.min.css'
import './scss/app.scss'
import 'admin-lte/dist/js/adminlte.min.js'

createApp(App).use(store).use(router).mount('#app')
